export function isset(obj) {
    return (typeof obj !== 'undefined' && obj !== null);
}
export function isStringable(obj) {
    return typeof obj.toString === 'function';
}
